module.exports = __webpack_public_path__ + "img/auth-error-03.688ffae9.png";